import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { License } from '../../../stores/types';
import { MODAL_TYPES, MenuItem, useGlobalModalContext } from '../../_ui';
import LicenseRenewModal from '../LicenseRenewModal';
import { getLicenseType, isLicenseTypeDemo, isNoDurationType } from '../utils';

interface RenewLicenseMenuItemProps {
  license: License;
}

export const RenewLicenseMenuItem: React.FC<RenewLicenseMenuItemProps> = ({ license }) => {
  const { showModal } = useGlobalModalContext();
  const { t } = useTranslation();

  const handleRenewLicenseClick = useCallback(() => {
    showModal(MODAL_TYPES.INFO_MODAL, {
      title: t('renew_license_dialog_title'),
      width: '561px',
      height: 'fit-content',
      bodyStyleClass: 'flex-grow',
      shouldCloseOnOverlayClick: false,
      onRenderBody: () => <LicenseRenewModal license={license} />,
    });
  }, [showModal, t, license]);

  const isDemoLicense = isLicenseTypeDemo(getLicenseType(license.type));

  return (
    <MenuItem
      label={t('renew_license_menu_text')}
      dataTestId='renew_license_menu_text'
      onClick={handleRenewLicenseClick}
      disabled={
        isDemoLicense ||
        !license.expirationDate ||
        isNoDurationType(license?.type, license?.includes4G)
      }
    />
  );
};
